import type { SharedDocumentKind } from './shared-document-query';

/**
 * RN-37 client-side — quando o `/meta` responde 410 o BFF não devolve NENHUM
 * dado (de propósito, RN-38/40), mas a copy do empty state "Link expirado"
 * varia por tipo (currículo × laudo). O token compartilhado é
 * `base64url(JSON).assinatura` (share-token.ts do BFF) e o `kind` viaja no
 * payload em claro, então dá para lê-lo no client SEM validar a assinatura —
 * é só escolha de copy, nunca decisão de acesso. Token ilegível → `null`
 * (o caller cai na copy de currículo).
 */
export function decodeShareTokenKind(token: string): SharedDocumentKind | null {
  try {
    const dot = token.indexOf('.');
    const body = dot > 0 ? token.slice(0, dot) : token;
    if (!body) return null;
    const base64 = body.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
    const payload = JSON.parse(new TextDecoder().decode(bytes)) as { kind?: unknown };
    return payload.kind === 'resume' || payload.kind === 'attestation' ? payload.kind : null;
  } catch {
    return null;
  }
}
